export enum KeyboardShortcuts {
  UPLOAD_DOCUMENTS = 'd',
}
